var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteBudget = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/budget") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/budget",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/budget"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "budget",
    transform: "translate(3.451, 3.5327)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65570988,4.19707317 C-1.31906704,9.07902439 -0.770821944,16.3141463 3.88926134,20.5112195 L10.8279883,11.8185366 L2.65570988,4.19707317 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.496162,0 C11.4790293,0 11.4618967,0 11.444764,0 C8.39515069,0 5.46546598,1.24682927 3.30675093,3.47707317 L11.496162,11.1160976 L11.496162,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1129377,11.7658537 L4.64309834,21.1258537 C9.71436544,24.9717073 16.875817,23.8653659 20.6278693,18.6673171 C22.0670127,16.6653659 22.855115,14.2419512 22.8722477,11.7658537 L12.1129377,11.7658537 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7324499,7.8497561 C17.7324499,7.56878049 17.6639193,7.35804878 17.5439907,7.2 C17.4069294,7.04195122 17.1842048,6.90146341 16.8586843,6.74341463 C16.0534493,6.4097561 15.4709389,6.07609756 15.1111531,5.74243902 C14.7513672,5.40878049 14.562908,4.91707317 14.562908,4.2497561 C14.562908,3.65268293 14.7513672,3.17853659 15.1454184,2.79219512 C15.5394695,2.40585366 16.0534493,2.19512195 16.7044904,2.12487805 L16.7044904,1.01853659 L17.5097253,1.01853659 L17.5097253,2.14243902 C18.1265011,2.2302439 18.6062155,2.49365854 18.9660014,2.91512195 C19.3257872,3.33658537 19.4971138,3.88097561 19.4799811,4.54829268 L19.4628485,4.56585366 L17.7667152,4.56585366 C17.7667152,4.1795122 17.6981846,3.89853659 17.5439907,3.72292683 C17.4069294,3.5297561 17.2184701,3.44195122 16.9786129,3.44195122 C16.7387557,3.44195122 16.5502964,3.51219512 16.4475005,3.6702439 C16.3275719,3.82829268 16.2761739,4.02146341 16.2761739,4.2497561 C16.2761739,4.49560976 16.3447045,4.68878049 16.4646331,4.82926829 C16.5845618,4.98731707 16.824419,5.12780488 17.1670722,5.28585366 C17.9551745,5.63707317 18.5376849,5.97073171 18.9146034,6.32195122 C19.2915219,6.67317073 19.4799811,7.16487805 19.4799811,7.79707317 C19.4799811,8.41170732 19.2915219,8.88585366 18.9146034,9.27219512 C18.5376849,9.64097561 18.0408378,9.86926829 17.4069294,9.92195122 L17.4069294,10.9756098 L16.6016944,10.9756098 L16.6016944,9.92195122 C15.9335207,9.85170732 15.3852756,9.62341463 14.9569591,9.2195122 C14.5286427,8.81560976 14.3059181,8.21853659 14.3230508,7.42829268 L14.3401834,7.39317073 L16.019184,7.39317073 C16.019184,7.83219512 16.1048473,8.13073171 16.2933066,8.32390244 C16.4817658,8.51707317 16.721623,8.60487805 17.0128782,8.60487805 C17.2527355,8.60487805 17.4411947,8.53463415 17.578256,8.37658537 C17.6639193,8.27121951 17.7324499,8.07804878 17.7324499,7.8497561 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteBudget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-budget.9d67435c7fb122d7ef33d58a9383e8c5.svg";